/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserCredentials } from './UserCredentials';

export type CaseDiagnosisAddonWritable = {
    readonly id?: number;
    readonly case_id?: number;
    content: string;
    addon_type: CaseDiagnosisAddonWritable.addon_type;
    number?: number | null;
    user: UserCredentials;
    signed_at?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
}

export namespace CaseDiagnosisAddonWritable {

    export enum addon_type {
        AI = 'ai',
        SCREEN = 'screen',
        FINALIZE = 'finalize',
        LIS_FINALIZED = 'lis-finalized',
        COMMENT = 'comment',
        AMEND = 'amend',
        ADDEND = 'addend',
        CORRECTION = 'correction',
        PRELIMINARY = 'preliminary',
    }


}
